// app/javascript/controllers/modal_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden'

    // Add animation
    this.element.classList.add('fade-in')
  }

  disconnect() {
    // Restore body scroll
    document.body.style.overflow = ''
  }

  close(event) {
    if (event) {
      event.preventDefault()
    }

    // Add fade out animation
    this.element.classList.add('fade-out')

    // Remove after animation
    setTimeout(() => {
      this.element.remove()
    }, 200)
  }

  closeBackground(event) {
    // Only close if clicking on the background, not the modal content
    if (event.target === this.element) {
      this.close(event)
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  // Handle escape key
  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.close(event)
    }
  }
}
